import WysiwygEditor from 'components/inputs/wysiwyg/WysiwygEditor';
import { IFormInputSpecWysiwyg } from 'pages/revisions-module/template-editor/editors/form/types';

/**
 * Preview for a text input.
 */
export default function WysiwygInputPreview({ spec }: { spec: IFormInputSpecWysiwyg }) {
  return <WysiwygEditor />;
}
